import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InvestFundService {

  // private urlBase = "https://maisretorno.com/api/v1/fundos/ss/"
  // private urlStats = "/stats/"
  // private urlItauFlexprev = this.urlBase + "itau-flexprev-master-indice-preco-rf-fic-fi" + this.urlStats;
  // private urlSulamerica = this.urlBase + "sul-america-inflatie-fi-rf-lp" + this.urlStats;
  // private urlVistaFia = this.urlBase + "vista-fia" + this.urlStats;
  // private urlIcatu = this.urlBase + "icatu-vanguarda-fic-fi-inflacao-longa-rf" + this.urlStats;
  // private urlDaycoval = this.urlBase + "daycoval-classic-fi-rf-cp" + this.urlStats;
  // private urlEquitas = this.urlBase + "equitas-selection-fic-fia" + this.urlStats;
  // private urlPacifico = this.urlBase + "pacifico-macro-fic-fim" + this.urlStats;

  //novo: https://api.maisretorno.com/v3/funds/stats/itau-rf-diferenciado-cp-fic-fi/details
  //antiga: https://api.maisretorno.com/v3/funds/stats/itau-rf-diferenciado-cp-fic-fi/details
  //novo: concat('https://api.maisretorno.com/v3/funds/stats/',body('Parse_JSON')?['fundName'],'/details')
  //antigo: concat('https://api.maisretorno.com/v3/funds/stats/',body('Parse_JSON')?['fundName'],'/details?start_date=1617148800000&end_date=1716948443000')

  //private urlBaseAzure = "https://prod-11.brazilsouth.logic.azure.com:443/workflows/d2824e5b1d574b7c90949911bc68949d/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=XmPBuCAECSGTOCTHj_Q0OIJQcoFElZH4sXGwWeUxFDk";
  //private urlBaseAzure = "https://prod-28.brazilsouth.logic.azure.com:443/workflows/55b2bb8905cd42f6b528a37d320c2594/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=Igzmdn5FAziJtnQDorybJSiGCbMxWb6e9i-gLx_I1h8";
  private urlBaseAzure = "https://prod-03.brazilsouth.logic.azure.com:443/workflows/5c59e43733c7472cab76382786bf949c/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=UNrZcZh8xVF8623KKB7QDceElw_-cT0HElQaa8xWnls";
  private urlAzureAllFunds = "https://prod-25.brazilsouth.logic.azure.com:443/workflows/b9235fd4e8ba4287b0e08e6238c51857/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=c7As1UGEQj9S06wrN6y7u-deXplM4PVA9VeT6sRjC9o";
  
  constructor(private http: HttpClient) { }

  //First API option - Azure and MaisRetorno
  getInvests(fundName: string): Observable<any> {
    return this.http.post<any>(this.urlBaseAzure, JSON.stringify({"fundName": fundName}));
  }

  getAllFundsList(): Observable<any> {
    return this.http.post<any>(this.urlAzureAllFunds, null);
  }

  //Second API option - Suno
  getInvestsSuno(fundCNPJ: string): Observable<any> {
    return this.http.get("https://api-fundos.sunoresearch.com.br/api/Report/GetReportsByCNPJ?cnpj="+ fundCNPJ);
  }

}